import { render, staticRenderFns } from "./LotteryRecord.vue?vue&type=template&id=af1cde54&scoped=true&"
import script from "./LotteryRecord.vue?vue&type=script&lang=js&"
export * from "./LotteryRecord.vue?vue&type=script&lang=js&"
import style0 from "./LotteryRecord.vue?vue&type=style&index=0&id=af1cde54&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af1cde54",
  null
  
)

export default component.exports